module.exports = __webpack_public_path__ + "img/secured.1f69ee47.svg";